import { render, staticRenderFns } from "./TimeComponent.vue?vue&type=template&id=0547f110&scoped=true&"
import script from "./TimeComponent.vue?vue&type=script&lang=js&"
export * from "./TimeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0547f110",
  null
  
)

export default component.exports